// App.jsx
import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import DemoLogin from './components/DemoLogin';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import PdfViewer from './components/PdfViewer';
import ModelViewer from './components/ModelViewer';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  const isDemo = window.location.pathname.startsWith("/demo") || window.location.pathname.startsWith("/endomyoma");
  const STORAGE_PREFIX = isDemo ? "demo_" : "prod_";
  
  const [user, setUser] = useState(() => {
    //const saved = localStorage.getItem("user");
    const saved = localStorage.getItem(`${STORAGE_PREFIX}user`);
    return saved ? JSON.parse(saved) : null;
  });
  const [appMode, setAppMode] = useState("production");
  const [banner, setBanner] = useState("");
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [view, setView] = useState('dashboard');
  const [lastActivity, setLastActivity] = useState(Date.now());

  // Fetch app mode from backend
  useEffect(() => {
    fetch(window.API_BASE_URL + "app-mode")
      .then((res) => res.json())
      .then((data) => setAppMode(data.mode || "production"))
      .catch(() => setAppMode("production")); // fallback
    fetch(window.API_BASE_URL + "banner")
      .then((res) => res.json())
      .then((data) => setBanner(data.banner || ""))
      .catch(() => setBanner("")); // fallback      
  }, []);
  
  // Save user in localStorage whenever it changes
  useEffect(() => {
    if (user) {
      localStorage.setItem(`${STORAGE_PREFIX}user`, JSON.stringify(user));
    } else {
      localStorage.removeItem(`${STORAGE_PREFIX}user`);
    }
  }, [user]);

  // Track activity and enforce 5-min idle timeout
  useEffect(() => {
    const updateActivity = () => setLastActivity(Date.now());
    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keydown", updateActivity);

    const interval = setInterval(() => {
      if (user && Date.now() - lastActivity > 5 * 60 * 1000) {
        logout();
      }
    }, 1000);

    return () => {
      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keydown", updateActivity);
      clearInterval(interval);
    };
  }, [user, lastActivity]);

  const logout = () => {
    setUser(null);
    setSelectedHospital(null);
    setView('dashboard');
    setSelectedPatient(null);
    localStorage.removeItem(`${STORAGE_PREFIX}user`);
    localStorage.removeItem("lastViewedPatientId");
  };

//  if (!user) {
//    return (
//      <Login
//        onLogin={(u) => {
//          setUser(u);
//          if (u.hospitals && u.hospitals.length > 0) {
//            setSelectedHospital(u.hospitals[0].id || u.hospitals[0]); // pick first hospital
//          }
//        }}
//      />
//    );
//  }
  
  if (!user) {
    // Show demo login if appMode is "demo"
    return (
      <Login
        onLogin={(u) => {
          setUser(u);
        }}
      />
    ); 
    
  }
  

  return (
    <div className="flex flex-col h-screen">
    
      {/* Fixed Header */}
      <Header
        user={user}
        appMode={appMode}
        banner={banner}
        selectedHospital={selectedHospital}
        setSelectedHospital={setSelectedHospital}
        onLogout={logout}
      />

      {/* Main Content - take available space for scrolling */}
      <main className="flex-1 overflow-y-auto bg-gray-100 px-6 pt-6 pb-6">
        {view === 'pdf' && selectedPatient ? (
          <PdfViewer
            fileId={selectedPatient?.fileId}
            patientId={selectedPatient?.patientId}
            onBack={() => setView('dashboard')}
          />        
        ) : view === 'model' && selectedPatient ? (
          <ModelViewer
            modelUrl={selectedPatient.modelUrl}
            patient={selectedPatient} 
            onBack={() => setView('dashboard')}
          />
        ) : user.role === 'admin' ? (
          <AdminDashboard 
            user={user}
            defaultTab="patients"
            onViewPdf={(p) => {
              setSelectedPatient(p);
              setView('pdf');
            }}
            onViewModel={(p) => {
              setSelectedPatient(p);
              setView('model');
            }}
          />
        ) : (
          <Dashboard
            user={user}
            appMode={appMode}
            onViewPdf={(p) => {
              setSelectedPatient(p);
              setView('pdf');
            }}
            onViewModel={(p) => {
              setSelectedPatient(p);
              setView('model');
            }}
          />
        )}
      </main>
      
      {/* Footer (half the header height) */}
      <Footer />
      
    </div>
  );
}

export default App;
